// src/store/mypage/mypageListsSaga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    deleteSavedRequested,
    deleteSavedSucceeded,
    deleteSavedFailed,

    deleteAlertRequested,
    deleteAlertSucceeded,
    deleteAlertFailed,

    removeInterestRequested,
    removeInterestSucceeded,
    removeInterestFailed,
    RemoveInterestPayload,
} from '../slice/mypageListsSlice';

import {
    deleteSavedEventById,
    deleteAlertById,
    removeInterestByKey,
} from '../../api/userListsApi';

/** 저장 이벤트 삭제 (기존 유지: 단일 id) */
function* handleDeleteSaved(action: ReturnType<typeof deleteSavedRequested>) {
    const id = action.payload;
    try {
        yield call(deleteSavedEventById, id);
        yield put(deleteSavedSucceeded(id));
    } catch (e: any) {
        const msg = e?.message || '삭제 실패';
        yield put(deleteSavedFailed({ id, error: msg }));
    }
}

/** 알림 삭제 (기존 유지) */
function* handleDeleteAlert(action: ReturnType<typeof deleteAlertRequested>) {
    const id = action.payload;
    try {
        yield call(deleteAlertById, id);
        yield put(deleteAlertSucceeded(id));
    } catch (e: any) {
        const msg = e?.message || '삭제 실패';
        yield put(deleteAlertFailed({ id, error: msg }));
    }
}

/**
 * 관심 테마 제거
 * (sector, feedId) 복합 payload로 변경됨
 * - removeInterestByKey도 이제 payload 객체를 받도록 API 쪽을 수정해야 함
 */
function* handleRemoveInterest(action: ReturnType<typeof removeInterestRequested>) {
    const payload: RemoveInterestPayload = action.payload;

    try {
        yield call(removeInterestByKey, payload);

        yield put(removeInterestSucceeded(payload));
    } catch (e: any) {
        const msg = e?.message || '삭제 실패';
        yield put(removeInterestFailed({ payload, error: msg }));
    }
}

export default function* mypageListsSaga() {
    yield takeEvery(deleteSavedRequested.type, handleDeleteSaved);
    yield takeEvery(deleteAlertRequested.type, handleDeleteAlert);
    yield takeEvery(removeInterestRequested.type, handleRemoveInterest);
}
